export const waPageWrap =
  'flex h-[calc(100dvh-5.5rem)] max-h-[calc(100dvh-5.5rem)] min-h-0 flex-col overflow-hidden rounded-none border-0 bg-white sm:min-h-[480px] sm:rounded-xl sm:border sm:border-gray-200 dark:bg-gray-900 dark:sm:border-gray-700';

export const waShell = 'flex min-h-0 flex-1 overflow-hidden';

export const waMobileTabs =
  'flex shrink-0 gap-0 overflow-x-auto border-b border-gray-200 bg-[#f0f2f5] dark:border-gray-700 dark:bg-[#202c33] [-webkit-overflow-scrolling:touch]';

export const waSubNavClass =
  'hidden w-14 shrink-0 flex-col items-center gap-1 overflow-y-auto border-r border-gray-200 bg-[#f0f2f5] py-3 dark:border-gray-700 dark:bg-gray-900/80 md:flex';

export const waSubNavItem = (active: boolean) =>
  `flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${
    active
      ? 'bg-[#25D366] text-white shadow-sm'
      : 'text-gray-500 hover:bg-white hover:text-gray-800 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-white'
  }`;

export const waChatListCol =
  'flex h-full min-h-0 w-full min-w-0 flex-col overflow-hidden border-r border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900 sm:w-72 md:w-80 lg:w-[320px]';

export const waThreadCol =
  'flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden bg-[#efeae2] dark:bg-[#0b141a]';

export const waContactCol =
  'hidden h-full min-h-0 w-full shrink-0 flex-col overflow-hidden border-l border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900 lg:flex lg:w-72 xl:w-80';

export const waWaHeader = 'bg-[#f0f2f5] px-4 py-3 dark:bg-[#202c33]';

export const waBubbleOut =
  'ml-auto max-w-[85%] rounded-lg rounded-tr-none bg-[#d9fdd3] px-3 py-2 text-sm text-gray-900 shadow-sm dark:bg-[#005c4b] dark:text-[#e9edef]';

export const waBubbleIn =
  'mr-auto max-w-[85%] rounded-lg rounded-tl-none bg-white px-3 py-2 text-sm text-gray-900 shadow-sm dark:bg-[#202c33] dark:text-[#e9edef]';

export function formatWaTime(iso: string) {
  try {
    const d = new Date(iso);
    const now = new Date();
    const diffDays = Math.floor((now.getTime() - d.getTime()) / 86400000);
    if (diffDays === 0) {
      return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
    }
    if (diffDays < 7) {
      return d.toLocaleDateString('en-IN', { weekday: 'short' });
    }
    return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
  } catch {
    return '';
  }
}

export function initials(name: string) {
  return (
    name
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase() || '')
      .join('') || '?'
  );
}

/** Full phone for admin WhatsApp hub (unmasked). */
export function formatDisplayPhone(countryCode: string, phoneNumber: string): string {
  const cc = String(countryCode || '+91').trim();
  const normalizedCc = cc.startsWith('+') ? cc : `+${cc.replace(/\D/g, '')}`;
  const num = String(phoneNumber || '').replace(/\D/g, '').slice(-10);
  return num ? `${normalizedCc} ${num}` : normalizedCc;
}
